import { styled } from "@woba/ds-web";

export const DropdownItemsWrapper = styled("div", {
  maxHeight: 280,
  overflow: "auto",
});

export const InputSearchWrapper = styled("div", {
  padding: "$space-03",
  paddingTop: "$space-02",
  borderBottomWidth: "$border-01",
  borderBottomStyle: "solid",
  borderBottomColor: "$neutral-300",
});

export const DropDownContent = styled("div", {
  width: "11rem",
  button: {
    minWidth: "6rem",
    width: "100%",
    "@media (max-width: 768px)": {
      width: "100%",
    },
  },
});
